import PropTypes from 'prop-types';
import React from 'react';

import { propTypesLocalization } from '../../constants/Proptypes';

import { propTypesPost } from '../../../templates/Post/Post.proptypes';
import { CardAppearance } from '../../../ui/Atoms/Card';
import CardCarousel from '../../../ui/Organisms/CardCarousel';

import { getCardList } from '../../utils/getCardList';

import { DocumentType } from '../../constants/Enums';
import * as S from './RecommendedGallery.styles';

export const RecommendedGallery = ({
  page,
  allPages,
  localization,
  hits,
  documentType,
}) => {
  if (!page || !allPages) {
    return null;
  }

  const isCategoryRelated = documentType === DocumentType.POST;
  const { uid: postId, data: { category: { uid: categoryId } = {} } = {} } =
    page || '';

  const {
    data: {
      recommended_section_label: recommendedSectionLabel,
      recommended_testimonial_label: recommendedTestimonialLabel,
    } = {},
  } = localization || '';

  const title = isCategoryRelated
    ? recommendedSectionLabel
    : recommendedTestimonialLabel;

  const hasHits = hits !== undefined;

  const recommendedTitle = hasHits ? recommendedSectionLabel : title;

  const sortPostByPosition = (a, b) => {
    const hitsA = hits.find(hit => hit.url.includes(a.node?.uid));
    const hitsB = hits.find(hit => hit.url.includes(b.node?.uid));

    return hitsA.__position - hitsB.__position;
  };

  const recommendedPosts = !hasHits
    ? allPages
        .filter(item =>
          isCategoryRelated
            ? item.node?.data?.category?.uid === categoryId &&
              item.node?.uid !== postId
            : item.node?.uid !== postId
        )
        .slice(0, 3)
    : allPages
        .filter(
          item =>
            item.node?.uid !== postId &&
            hits.find(hit => hit.url.includes(item.node?.uid))
        )
        .sort(sortPostByPosition)
        .slice(0, 3);

  const cardList = getCardList({
    items: recommendedPosts,
    cardAppearance: CardAppearance.SIMPLE,
    isFromEdges: false,
  });

  const hasItems = cardList?.length >= 3;

  return (
    <S.Wrapper hasItems={hasItems}>
      {cardList && (
        <CardCarousel isGallery={true} title={recommendedTitle}>
          {cardList}
        </CardCarousel>
      )}
    </S.Wrapper>
  );
};

RecommendedGallery.propTypes = {
  /**
   * Post list. The Carousel will be displayed only if there is
   * 3 article different from the current one but from the same Category.
   */
  allPages: PropTypes.arrayOf(
    PropTypes.shape({
      node: PropTypes.shape(propTypesPost),
    })
  ),
  /**
   * Prismic document type.
   */
  documentType: PropTypes.string,

  /**
   * Algolia hits, results from search engine
   */
  hits: PropTypes.arrayOf(
    PropTypes.shape({
      category: PropTypes.string,
      description: PropTypes.string,
      language: PropTypes.string,
      objectID: PropTypes.string,
      tag1: PropTypes.string,
      tag2: PropTypes.string,
      tag3: PropTypes.string,
      title: PropTypes.string,
      url: PropTypes.string,
    })
  ),
  /**
   * Localization document.
   */
  localization: PropTypes.shape(propTypesLocalization),
  /**
   * Post document.
   */
  page: PropTypes.shape(propTypesPost),
};
